import React, { Component, useEffect } from 'react';
import { Breadcrumb, BreadcrumbItem, Label, Button, Alert,
         Modal, ModalHeader, ModalBody, Tooltip } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import { Control, Form as ReduxForm} from 'react-redux-form';
import { Logging, CustomLoading } from './LoadingComponent';
import { connect } from 'react-redux';
import { port_backtest_actions } from '../redux/ActionType';
import { RenderVirtualTable } from './TableComponent';
import { CustomSelect, CustomListSelect, unique_values, sort_by, previous_date } from './Functions';
import { PiePlot } from './PlotComponent';
import { CSVLink } from "react-csv";
import { postRequest } from '../redux/ActionCreators';
import { Auth } from 'aws-amplify';

// import 'rsuite/dist/styles/rsuite-default.css';

const mapStateToProps = state => {
  return {
    port_alloc_backtest: state.port_alloc_backtest,
    backtest_params: state.backtest_params,
    port_metrics: state.port_metrics, 
    user_wm: state.user_wm,
    port_groups: state.port_groups
  };
};

class PortParams extends Component {
    constructor(props){
        super(props);
        this.state = {
          msg:null,
          msg_report:null,
          show_msg:true,
          loading_groups:false,
          gen_report:false,
          generating_report:false,
          loading_allocation:false,
          fields_tooltip:{rebal_port:false, rebal_bench:false, sync_rebal_dates:false}
        };
        this.runBacktest = this.runBacktest.bind(this);
        this.openReportModal = this.openReportModal.bind(this);
        this.loadGroups = this.loadGroups.bind(this);
        this.genReport = this.genReport.bind(this);
        this.queryAllocation = this.queryAllocation.bind(this);
    }

    async queryAllocation(){
      if (this.props.backtest_params.port_name==null && this.props.backtest_params.bench_name==null) {
        this.setState({msg:'Seleccionar al menos 1 portafolio.'});
      } else {
        this.setState({loading_allocation:true});
        try {
          const ports_alloc = await postRequest({
            port_id:[].concat(this.props.backtest_params.port_name || []).concat(this.props.backtest_params.bench_name || []), 
            last_update:false,
            res_url:false,
            own_only:this.props.user_wm.data?.role==3 ? true : false,
            port_groups:this.props.user_wm.data?.port_groups
          }, 'port_saa');
          this.props.changeModel("port_alloc_backtest", ports_alloc.data);
        this.setState({loading_allocation:false});
        } catch(error) {
          this.setState({
            msg:`Error consultado portafolio (${error.message}).`,
            loading_allocation:false
          });
          return;
        }
      }
    }

    async openReportModal(){
      if (!this.props.backtest_params.multiple_ports && this.props.backtest_params.port_name==null) {
        this.setState({msg:'Seleccionar portafolio.'});
      } else if (this.props.backtest_params.multiple_ports && (this.props.backtest_params?.ports==null || this.props.backtest_params?.ports.length==0)) {
        this.setState({msg:'Seleccionar portafolios.'});
      } else if (!this.props.backtest_params.multiple_ports) {
        this.setState({msg:'Para generar reportes debes seleccionar la opción de de de múltiples portafolios.'});
      } else {
        console.log("Open Modal");
        this.setState({gen_report:true});
      }
    }
    async genReport(){
      // this.setState({generating_report:true});
      console.log("Generate report");
      if (this.props.backtest_params.report_name==null || this.props.backtest_params.report_name=="") {
        this.setState({msg_report:'Seleccionar reporte.'});
      } else {
        this.setState({
          generating_report:true,
          gen_report:false
        });
        this.setState({show_msg:true});
        let backtest_metrics;
        if (this.props.backtest_params.multiple_ports){
          await this.props.changeModel("backtest_params.port_name", null);
          backtest_metrics = await this.props.fetchData(
            {...this.props.backtest_params,
              ini_date:!this.props.backtest_params.activate_initial_date ? previous_date(this.props.backtest_params.range, this.props.backtest_params.ref_date) : this.props.backtest_params.ini_date,
              ports:this.props.backtest_params.ports.map(k=>{
                      return {name:k.includes(" - Tactico") ? k : k + " - Tactico", bench:k.includes(" - Tactico") ? k.replace(" - Tactico", "") : k};
                    }),
              return_series:true,
              own_only:this.props.user_wm.data?.role==3 ? true : false,
              port_groups:this.props.user_wm.data?.port_groups
            },
            'port_backtest_mult', port_backtest_actions);
        } else {
          backtest_metrics = await this.props.fetchData(
            {
              ...this.props.backtest_params,
              ini_date:!this.props.backtest_params.activate_initial_date ? previous_date(this.props.backtest_params.range, this.props.backtest_params.ref_date) : this.props.backtest_params.ini_date,
              own_only:this.props.user_wm.data?.role==3 ? true : false,
              port_groups:this.props.user_wm.data?.port_groups
            },

            'port_backtest', port_backtest_actions);
        }
        if (backtest_metrics?.success){
          try{
            console.log("success");
            const resp = await postRequest(
              {
                ...this.props.port_metrics.data,
                ...this.props.backtest_params,
                ini_date:!this.props.backtest_params.activate_initial_date ? previous_date(this.props.backtest_params.range, this.props.backtest_params.ref_date) : this.props.backtest_params.ini_date
              },
              'reports_backtest_mult');
            this.setState({generating_report:false});
            if (resp.status=="ok"){
              window.location.replace(String(resp.url));
            }
          } catch(error) {
            this.setState({
              msg:`Error generando reporte (${error.message}).`,
              generating_report:false
            });
          }
        }
      }
    }

    async loadGroups(){
      this.setState({loading_groups:true});
      try {
        const userInfo = await Auth.currentUserInfo() //`${(await Auth.currentUserInfo()).username}`;
        const query_str = this.props.user_wm.data.role==1 ? `SELECT PortId, GroupId FROM PortfolioGroups` :
                          `SELECT pg.PortId, pg.GroupId FROM PortfolioGroups as pg JOIN UserGroups as ug ON pg.GroupId=ug.GroupId WHERE ug.Username='${userInfo.username.split("@")[0]}'`;
        const groups = await postRequest({
            database:'wmdb',
            query_string:query_str
            },'query_database');
        await this.props.changeModel('port_groups', groups.data);
        this.setState({loading_groups:false});
  
      } catch (error) {
        console.error('Error getting response:', error);
        this.setState({loading_groups:false});
      }
    }

    async runBacktest(){
      if (!this.props.backtest_params.multiple_ports && this.props.backtest_params.port_name==null) {
        this.setState({msg:'Seleccionar portafolio.'});
      } else if (this.props.backtest_params.multiple_ports && (this.props.backtest_params.ports==null || this.props.backtest_params.ports.length==0)) {
        this.setState({msg:'Seleccionar portafolios.'});
      } else {
        this.setState({show_msg:true});
        let backtest_metrics;
        if (this.props.backtest_params.multiple_ports){
          await this.props.changeModel("backtest_params.port_name", null);
          const ports_data = this.props.backtest_params.tac_ports ? 
                              this.props.backtest_params.ports.map(k=>{
                                return {name:k.includes(" - Tactico") ? k : k + " - Tactico", bench:k.includes(" - Tactico") ? k.replace(" - Tactico", "") : k};
                              }) :
                              this.props.backtest_params.ports.map(k=>{
                                return {name:k, bench:null};
                              });
          backtest_metrics = await this.props.fetchData(
            {...this.props.backtest_params,
              ini_date:!this.props.backtest_params.activate_initial_date ? previous_date(this.props.backtest_params.range, this.props.backtest_params.ref_date) : this.props.backtest_params.ini_date,
              ports:ports_data
            },
            'port_backtest_mult', port_backtest_actions);
            
        } else {
          backtest_metrics = await this.props.fetchData(
            {...this.props.backtest_params,
              ini_date:!this.props.backtest_params.activate_initial_date ? previous_date(this.props.backtest_params.range, this.props.backtest_params.ref_date) : this.props.backtest_params.ini_date,
              port_name:this.props.backtest_params.port_name.includes("@Serie") ? null : this.props.backtest_params.port_name,
              port_weights:this.props.backtest_params.port_name.includes("@Serie") ? [{name:this.props.backtest_params.port_name.split("@Serie")[0], w:1}] : null,
              bench_name:this.props.backtest_params.bench_name?.includes("@Serie") ? null : this.props.backtest_params.bench_name,
              bench_weights:this.props.backtest_params.bench_name?.includes("@Serie") ? [{name:this.props.backtest_params.bench_name.split("@Serie")[0], w:1}] : null
            },
            'port_backtest', port_backtest_actions);
        }
        if (backtest_metrics?.success){
          this.props.history.push(`/portfolio/backtest/results`);          
        }
      }
  }
    
    render(){
        if(this.props.user_wm.isLogging){
          return(
              <div className="container">
                <div className="row mt-5 justify-content-center">
                  <div className="col-auto">
                      <h4>Backtesting</h4>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <Logging/>
                </div>
              </div>
          );
        }else if(this.props.port_metrics.isLoading){
          return(
              <div className="container">
                <div className="row mt-5 justify-content-center">
                  <div className="col-auto">
                      <h4>Backtesting</h4>
                  </div>
                </div>
                <div className="row m-3 justify-content-center">
                  <div className="col-auto">
                    <Breadcrumb>
                        <BreadcrumbItem active>Parámetros</BreadcrumbItem>
                        <BreadcrumbItem><Link to='/portfolio/backtest/results'>Resultados</Link></BreadcrumbItem>
                    </Breadcrumb>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <CustomLoading msg="calculando métricas" icon="fa-calculator"/>
                </div>
              </div>
          );
        } else if(this.state.generating_report){
          return(
              <div className="container">
                <div className="row mt-5 justify-content-center">
                  <div className="col-auto">
                      <h4>Backtesting</h4>
                  </div>
                </div>
                <div className="row m-3 justify-content-center">
                  <div className="col-auto">
                    <Breadcrumb>
                        <BreadcrumbItem active>Parámetros</BreadcrumbItem>
                        <BreadcrumbItem><Link to='/portfolio/backtest/results'>Resultados</Link></BreadcrumbItem>
                    </Breadcrumb>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <CustomLoading msg="generando reporte. Por favor no salgas de esta página" icon="fa-paperclip"/>
                </div>
              </div>
          );
        } else {
            return(
                <div className="container">
                    <div className="row mt-5 justify-content-center" id="back">
                      <div className="col-auto">
                          <h4>Backtesting</h4>
                      </div>
                    </div>
                    <div className="row m-3 justify-content-center">
                      <div className="col-auto">
                        <Breadcrumb>
                            <BreadcrumbItem active>Parámetros</BreadcrumbItem>
                            <BreadcrumbItem><Link to='/portfolio/backtest/results'>Resultados</Link></BreadcrumbItem>
                        </Breadcrumb>
                      </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-9">
                            <ReduxForm model="backtest_params">
                                {this.state.show_msg && this.props.port_metrics.errMess!=='' && this.props.port_metrics.errMess!==null ?
                                  <div className="row mt-4 justify-content-center">
                                    <div className="col-6 m-1">
                                      <Alert
                                        color={this.props.port_metrics.errMess.includes('Error') ? 'danger':'secondary'}
                                        isOpen={this.state.show_msg && this.props.port_metrics.errMess!=='' && this.props.port_metrics.errMess!==null} 
                                        toggle={()=>this.setState({show_msg:false})}>
                                          {this.props.port_metrics.errMess}
                                      </Alert>
                                    </div>
                                  </div>
                                  :<></>
                                }
                                <div className='row justify-content-center align-items-end m-1'>
                                  <div className='col-auto'>
                                    <Control.checkbox model=".multiple_ports"
                                        className="form-check-input"/>
                                        <small>{'   '}múltiples portafolios</small>
                                  </div>
                                  {this.props.backtest_params.multiple_ports ?
                                    <div className='col-auto'>
                                      <Control.checkbox model=".tac_ports"
                                          className="form-check-input"/>
                                          <small>{'   '}portafolios tácticos</small>
                                    </div>
                                  : false
                                  }
                                </div>
                                {this.props.backtest_params.multiple_ports ?
                                  <>
                                    <div className='row justify-content-center align-items-center m-3'>
                                      <div className='col-8'>
                                        <label><small>Portafolios</small></label>
                                        <CustomSelect
                                          className="basic-multi-select"
                                          options={this.props.user_wm.data.ports_list}
                                          value={(this.props.backtest_params.ports || []).map(x=>{
                                            return {value:x, label:x};
                                          })}
                                          isClearable={true}
                                          isSearchable={true}
                                          onChange={(e)=>this.props.changeModel("backtest_params.ports", e.map(x=>x.value))}  
                                          placeholder="seleccionar portafolios..."
                                        />
                                      </div>
                                      {this.state.loading_groups ?
                                        <div className='col-4'>
                                          <CustomLoading msg="actualizando grupos de portafolios" icon="fa-pencil"/>
                                        </div>
                                      : this.props.port_groups!==null ?
                                      <div className='col-4'>
                                        <label><small>Grupos</small></label>
                                        <CustomListSelect
                                          options={unique_values(this.props.port_groups, 'GroupId').map(x=>{
                                            return {value:x, label:x};
                                          })}
                                          isClearable={true}
                                          value={this.props.backtest_params.port_group==null ? null : {value:this.props.backtest_params.port_group, label:this.props.backtest_params.port_group}}
                                          onChange={(e)=>{
                                           this.props.changeModel("backtest_params.port_group", e==null ? null : e.value);
                                           if (e!==null){
                                             this.props.changeModel("backtest_params.ports", this.props.port_groups.filter(k=>k.GroupId==e.value).map(k=>k.PortId));
                                           }
                                          }}
                                          itemSize={50}
                                          className="basic-single"
                                          placeholder="Seleccionar..."
                                        />
                                      </div>
                                      :
                                        <div className='col-4'>
                                          <Button className='link-btn'
                                            onClick={this.loadGroups}
                                          >
                                            actualizar grupos&darr;
                                          </Button>
                                        </div>
       
                                      }
                                    </div>
                                  </>
                                :
                                  <>
                                    <div className='row justify-content-center align-items-end m-3'>
                                      <div className='col-5'>
                                        <label><small>Portafolio 1</small></label>
                                        <CustomListSelect
                                          options={this.props.user_wm.data.ports_list.concat(this.props.user_wm.data.assets.map(x=>{
                                            return {value:`${x.Asset}@Serie`, label:x.Isin=="" ? `${x.Asset} | ${x.Ticker}@Serie` : `${x.Asset} | ${x.Isin}@Serie`};
                                          }).sort(sort_by("label")))}
                                          isClearable={true}
                                          value={this.props.backtest_params.port_name==null ? null : {value:this.props.backtest_params.port_name, label:this.props.backtest_params.port_name}}
                                          onChange={(e)=>this.props.changeModel("backtest_params.port_name", e==null ? null : e.value)}
                                          itemSize={50}
                                          className="basic-single"
                                          placeholder="seleccionar portafolio"
                                        />
                                      </div>
                                      <div className='col-5'>
                                        <label><small>Portafolio 2 (Benchmark)</small></label>
                                        <CustomListSelect
                                          options={this.props.user_wm.data.ports_list.concat(this.props.user_wm.data.assets.map(x=>{
                                            return {value:`${x.Asset}@Serie`, label:x.Isin=="" ? `${x.Asset} | ${x.Ticker}@Serie` : `${x.Asset} | ${x.Isin}@Serie`};
                                          }).sort(sort_by("label")))}
                                          isClearable={true}
                                          value={this.props.backtest_params.bench_name==null ? null : {value:this.props.backtest_params.bench_name, label:this.props.backtest_params.bench_name}}
                                          onChange={(e)=>this.props.changeModel("backtest_params.bench_name", e==null ? null : e.value)}
                                          itemSize={50}
                                          className="basic-single"
                                          placeholder="seleccionar benchmark"
                                        />
                                      </div>
                                    </div>
                                  </>
                                }
                                <div className='row m-3 justify-content-center align-items-end'>
                                  <div className='col-auto'>
                                    <Control.checkbox model=".activate_initial_date"
                                        className="form-check-input"/>
                                    <small>{'  '} activar fecha inicial</small>
                                  </div>

                                  {this.props.backtest_params.activate_initial_date ?
                                    <div className='col-3'>
                                        <label htmlFor=".ini_date"><small>Fecha Inicial</small></label>
                                        <Control.text model=".ini_date" type="date"
                                            name="ini_date"
                                            dafaultvalue="2011-01-01"
                                            dateform="YYYY-MM-DD"
                                            className="form-control"
                                            updateOn='blur'
                                            disabled={false}
                                        />
                                    </div>
                                    :
                                    <div className='col-1'>
                                        <label htmlFor=".range"><small>Rango</small></label>
                                        <Control.select 
                                            model=".range" 
                                            type="select" 
                                            name="range"
                                            className="form-control"
                                            disabled={false}
                                            >
                                            <option>YTD</option>
                                            <option>3M</option>
                                            <option>6M</option>
                                            <option>1Y</option>
                                            <option>500D</option>
                                            <option>3Y</option>
                                            <option>5Y</option>
                                            <option>10Y</option>
                                        </Control.select>
                                    </div>
                                  }
                                    <div className='col-3'>
                                        <label htmlFor=".ref_date"><small>Fecha Final</small></label>
                                        <Control.text model=".ref_date" type="date"
                                            name="ref_date"
                                            dateform="YYYY-MM-DD"
                                            className="form-control"
                                            updateOn='blur'
                                            disabled={false}
                                        />
                                    </div>
                                    <div className='col-2'>
                                        <label htmlFor=".ref_curr"><small>Moneda</small></label>
                                        <Control.select 
                                            model=".ref_curr" 
                                            type="select" 
                                            name="ref_curr"
                                            className="form-control"
                                            disabled={false}
                                            >
                                            <option>USD</option>
                                            <option>CLP</option>
                                            <option>CLF</option>
                                            <option>MXN</option>
                                            <option>COP</option>
                                            <option>UVR</option>
                                            <option>PEN</option>
                                            <option>UYU</option>
                                        </Control.select>
                                    </div>
                                </div>
                                <div className='row justify-content-center align-items-end m-4'>
                                    <div className='col-3'>
                                      <Control.checkbox model=".rebal_dates_db"
                                          className="form-check-input"/>
                                      <span href="#" id="rebal_port"><small>{'  '}Rebalanceo Portafolio - Base de Datos</small></span>
                                      <Tooltip
                                          hideArrow={true} placement="right" 
                                          isOpen={this.state.fields_tooltip.rebal_port} 
                                          target="rebal_port" toggle={()=>this.setState({fields_tooltip:{rebal_port:!this.state.fields_tooltip.rebal_port}})}
                                          fade={false}
                                      >
                                      <p><small>Backtest con rebalanceo considerando fechas registradas en la base de datos.</small></p>
                                      </Tooltip>

                                    </div>
                                    <div className='col-3'>
                                      <Control.checkbox model=".rebal_dates_db_bench"
                                          className="form-check-input"
                                          disabled={this.props.backtest_params.sync_rebal_dates || this.props.backtest_params.bench_name==null}
                                          />
                                      <span href="#" id="rebal_bench"><small>{'  '}Rebalanceo Benchmark - Base de Datos</small></span>
                                      <Tooltip
                                          hideArrow={true} placement="right" 
                                          isOpen={this.state.fields_tooltip.rebal_bench} 
                                          target="rebal_bench" toggle={()=>this.setState({fields_tooltip:{rebal_bench:!this.state.fields_tooltip.rebal_bench}})}
                                      >
                                      <p><small>Backtest con rebalanceo considerando fechas registradas en la base de datos.</small></p>
                                      </Tooltip>

                                    </div>
                                </div>
                                <div className='row justify-content-center align-items-end m-4'>
                                    <div className='col-3'>
                                      <Control.checkbox model=".invest_assets"
                                          className="form-check-input"/>
                                          <small>{'  '}Activos Invertibles Port.</small>
                                    </div>
                                    <div className='col-3'>
                                      <Control.checkbox model=".invest_assets_bench"
                                          className="form-check-input"
                                          disabled={this.props.backtest_params.bench_name==null}
                                          />
                                          <small>{'  '}Activos Invertibles Bench.</small>
                                    </div>
                                </div>
                                <div className='row justify-content-center align-items-end m-4'>
                                    <div className='col-3'>
                                        <label htmlFor=".per"><small>Periodo Retornos</small></label>
                                        <Control.select model=".per" type="select" name="per"
                                            className="form-control">
                                            <option value="daily">Diario</option>
                                            <option value="monthly">Mensual</option>
                                            <option value="quarterly">Trimestral</option>
                                        </Control.select>
                                    </div>
                                    <div className='col-3'>
                                        <label htmlFor=".rebal_period"><small>Periodo Rebalanceo</small></label>
                                        <Control.select model=".rebal_period" type="select" name="rebal_period"
                                            className="form-control">
                                            <option value="monthly">Mensual</option>
                                            <option value="quarterly">Trimestral</option>
                                            <option value="yearly">Anual</option>
                                        </Control.select>
                                    </div>
                                </div>
                                <div className='row justify-content-center align-items-start m-4'>
                                    <div className='col-3'>
                                      <Control.checkbox model=".sync_rebal_dates"
                                          className="form-check-input"
                                          disabled={this.props.backtest_params.bench_name==null}
                                          />
                                      <span href="#" id="sync_rebal_dates"><small>{'  '}Sincronizar rebalanceo</small></span>
                                      <Tooltip
                                          hideArrow={true} placement="right" 
                                          isOpen={this.state.fields_tooltip.sync_rebal_dates} 
                                          target="sync_rebal_dates" toggle={()=>this.setState({fields_tooltip:{sync_rebal_dates:!this.state.fields_tooltip.sync_rebal_dates}})}
                                      >
                                      <p><small>Si se activa esta opción, se sincronizan las fechas de rebalanceo del benchmark con el portafolio.</small></p>
                                      </Tooltip>
                                    </div>
                                    <div className='col-3'>
                                      <Control.checkbox model=".complete_rebal_dates_db"
                                          className="form-check-input"
                                          disabled={!this.props.backtest_params.rebal_dates_db && !this.props.backtest_params.rebal_dates_db_bench}
                                          />
                                      <span href="#" id="complete_rebal_dates_db"><small>{'  '}Completar fechas de rebalanceo en BD</small></span>
                                      <Tooltip
                                          hideArrow={true} placement="right" 
                                          isOpen={this.state.fields_tooltip.complete_rebal_dates_db} 
                                          target="complete_rebal_dates_db" toggle={()=>this.setState({fields_tooltip:{complete_rebal_dates_db:!this.state.fields_tooltip.complete_rebal_dates_db}})}
                                      >
                                      <p><small>Si se activa esta opción, se completan fechas de rebalanceo registrada en la BD, con fechas simuladas a partir del Periodicidad de Rebalanceo seleccionado.</small></p>
                                      </Tooltip>
                                    </div>
                                    <div className='col-3'>
                                      <Control.checkbox model=".complete_tact"
                                          className="form-check-input"
                                          disabled={this.props.backtest_params.bench_name==null}
                                          />
                                      <span href="#" id="complete_tact"><small>{'  '}Completar portafolio activo con Benchmark</small></span>
                                      <Tooltip
                                          hideArrow={true} placement="right" 
                                          isOpen={this.state.fields_tooltip.complete_tact} 
                                          target="complete_tact" toggle={()=>this.setState({fields_tooltip:{complete_tact:!this.state.fields_tooltip.complete_tact}})}
                                      >
                                      <p><small>Si se activa esta opción y está activa la opción "Rebalanceo Portafolio - Base de Datos", entre la fecha de inicio del backtest y la primera fecha del portafolio en la base de datos, se recontruye una serie con base en el allocation del Portafolio 2/Benchmark.</small></p>
                                      </Tooltip>
                                    </div>
                                </div>
                                <div className="row justify-content-center mt-5">
                                    <div className='col-auto'>
                                        <Button 
                                            className="btn-corp"
                                            onClick={this.runBacktest}>
                                            Ejecutar backtest
                                        </Button>
                                    </div>
                                    <div className='col-auto'>
                                        <Button 
                                            className="btn-corp"
                                            onClick={this.openReportModal}>
                                            Generar Reporte
                                        </Button>
                                    </div>
                                    {this.state.loading_allocation ?
                                      <div className='col-2'>
                                        <CustomLoading mt="0" msg="Cargando allocation. Por favor no salgas de esta página" />
                                      </div>
                                    : 
                                      <div className='col-auto'>
                                          <Button 
                                              className="btn-corp"
                                              onClick={this.queryAllocation}>
                                              Ver Allocation
                                          </Button>
                                      </div>
                                    }
                                </div>
                                <div className="row mt-4 justify-content-center">
                                  <div className="col-6 m-3">
                                    <Alert
                                      color='secondary'
                                      isOpen={this.state.msg!=='' && this.state.msg!==null} 
                                      toggle={()=>this.setState({msg:null})}>
                                        {this.state.msg}
                                    </Alert>
                                  </div>
                                </div>
                            </ReduxForm>

                            <Modal isOpen={this.state.gen_report} toggle={()=>this.setState({gen_report:!this.state.gen_report})}>
                              <ModalHeader toggle={()=>this.setState({gen_report:!this.state.gen_report})}>Generar Reporte</ModalHeader>
                              <ModalBody>
                                  <div className="row m-4 justify-content-center">
                                    <div className="col-8 m-1">
                                      <CustomListSelect
                                        options={[{label:"Reporte Atribución", value:"Reporte Atribucion"}, {label:"Reporte EEUU", value:"Reporte EEUU"}].map(x=>{
                                          return {value:x.value, label:x.label};
                                        })}
                                        isClearable={true}
                                        value={this.props.backtest_params.report_name!=null ? {value:this.props.backtest_params.report_name, label:this.props.backtest_params.report_name} : null}
                                        onChange={(e)=>this.props.changeModel("backtest_params.report_name", e?.value)}
                                        itemSize={50}
                                        className="basic-single"
                                        placeholder="Seleccionar..."
                                      />
                                    </div>
                                  </div>
                                  <div className="row m-1 justify-content-center">
                                    <div className="col-auto m-1">
                                      <Button 
                                        onClick={this.genReport}
                                        className="btn-corp">
                                          Descargar reporte
                                      </Button>
                                    </div>
                                  </div>
                                  <div className="row mt-4 justify-content-center">
                                    <div className="col-6">
                                      <Alert
                                        color='secondary'
                                        isOpen={this.state.msg_report!=='' && this.state.msg_report!==null} 
                                        toggle={()=>this.setState({msg_report:null})}>
                                          {this.state.msg_report}
                                      </Alert>
                                    </div>
                                  </div>
                              </ModalBody>  
                            </Modal>
                        </div>
                    </div>
                    {this.props.port_alloc_backtest ?
                    <>
                      <div className='row justify-content-center align-items-end mt-5'>
                        <div className='col'>
                          <hr></hr>
                        </div>
                      </div>
                      <div className='row justify-content-center align-items-end mt-3'>
                        <div className='col'>
                          <h5>Allocation</h5>
                          <a className='linkcol' href='#back'>volver&uarr;</a>
                        </div>
                      </div>
                      <div className='row justify-content-center align-items-end mt-5'>
                          <div className='col-3'>
                            <h6>Portafolio</h6>
                            <CustomListSelect
                              options={unique_values(this.props.port_alloc_backtest, 'PortId').map(x=>{
                                return {value:x, label:x};
                              })}
                              isClearable={true}
                              value={this.props.backtest_params.port_alloc_name==null ? null : {value:this.props.backtest_params.port_alloc_name, label:this.props.backtest_params.port_alloc_name}}
                              onChange={(e)=>{this.props.changeModel("backtest_params.port_alloc_name", e==null ? null : e.value)}}
                              itemSize={50}
                              className="basic-single"
                              placeholder="Seleccionar..."
                            />
                          </div>
                          <div className='col-2'>
                            <h6>Fecha</h6>
                            <CustomListSelect
                              options={unique_values(this.props.port_alloc_backtest.filter(k=>k.PortId==this.props.backtest_params.port_alloc_name), 'DatePort').map(x=>{
                                return {value:x, label:x};
                              })}
                              isClearable={true}
                              value={this.props.backtest_params.port_alloc_date==null ? null : {value:this.props.backtest_params.port_alloc_date, label:this.props.backtest_params.port_alloc_date}}
                              onChange={(e)=>{this.props.changeModel("backtest_params.port_alloc_date", e==null ? null : e.value)}}
                              itemSize={50}
                              className="basic-single"
                              placeholder="Seleccionar..."
                            />
                          </div>
                      </div>
                      {this.props.port_alloc_backtest.filter(k=>k.PortId==this.props.backtest_params.port_alloc_name && k.DatePort==this.props.backtest_params.port_alloc_date).length>0 ?
                      <div className='row justify-content-center align-items-center mt-4'>
                          <div className='col-6'>
                            <div className="row justify-content-center">
                              <div className='col-auto'>
                                <RenderVirtualTable 
                                  data={this.props.port_alloc_backtest.filter(k=>k.PortId==this.props.backtest_params.port_alloc_name && k.DatePort==this.props.backtest_params.port_alloc_date).map(k=>{
                                    return {Activo:k.Asset , Peso:k.Weight*100};
                                  }).sort(sort_by("Peso", "desc"))} 
                                  to_perc={[false, true]}
                                  cell_width={['250px', "150px"]}
                                  item_size={40}
                                  style="black"
                                />
                              </div>
                            </div>
                            <div className='row'>
                              <div className='col'>
                                <CSVLink className='link-btn' data={this.props.port_alloc_backtest.filter(k=>k.PortId==this.props.backtest_params.port_alloc_name)} filename="allocation"><small>Descargar allocation&darr;</small></CSVLink>
                              </div>
                            </div>
                          </div>
                          <div className='col-6'>
                            <PiePlot 
                              data={this.props.port_alloc_backtest.filter(k=>k.PortId==this.props.backtest_params.port_alloc_name && k.DatePort==this.props.backtest_params.port_alloc_date).map(k=>{
                                return {name:k.Asset , value:k.Weight*100};
                              }).sort(sort_by("value", "desc"))}
                              legend={true}
                              percTooltip={true}
                              legendHeight={150}
                              width={550}
                              height={500}
                              outerRadius={100}
                              dataKey="value"
                              nameKey="name"
                            />
                          </div>
                      </div>
                      :null
                      }
                    </>
                    : null
                    }
                </div>
            );
        }
    }
}

export default withRouter(connect(mapStateToProps)(PortParams));
